import { gql } from "@apollo/client";

const GET_ALL_MODEL_FEATURE_LIST = gql`
  {
    fetchFeatureModelConfigList {
      id
      groupId
      groupName
      featureId
      featureName
      grpFeatureId
      modelName
      modelDesc
      variantId
      variantName
      variantGrpImgUrl
      detail
      modelImgUrl
      price
      equipmentUrl
      operatorManualPdfUrl
      hp
      productName
      grpFeatureVariantId
      grpFeatureDtlId
      isModelDtlEnabled
    }
  }
`;

const GET_GROUP_FEATURE_LIST = gql`
  {
    fetchProductGrpFeatureList {
      grpFeatureId
      groupId
      groupName
      featureId
      featureName
    }
  }
`;

export { GET_ALL_MODEL_FEATURE_LIST, GET_GROUP_FEATURE_LIST };
